import React, { useState } from "react";

interface ReasonModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (reason: string) => void;
  title: string;
  description: string;
  confirmText?: string;
  confirmColor?: string;
  placeholder?: string;
  processing?: boolean;
}

const overlay: React.CSSProperties = {
  position: "fixed", inset: 0, zIndex: 10001,
  background: "rgba(15,23,42,0.4)", backdropFilter: "blur(4px)",
  display: "flex", alignItems: "center", justifyContent: "center",
};

const modal: React.CSSProperties = {
  background: "#ffffff", borderRadius: 16, width: "100%", maxWidth: "440px",
  padding: "24px", boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
  display: "flex", flexDirection: "column", gap: "16px",
  border: "1px solid #e2e8f0",
};

const titleStyle: React.CSSProperties = { margin: 0, fontSize: "18px", fontWeight: 700, color: "#1e293b" };
const descStyle: React.CSSProperties = { margin: 0, fontSize: "14px", color: "#64748b", lineHeight: "1.5" };

const textareaStyle: React.CSSProperties = {
  width: "100%", minHeight: "100px", padding: "12px", borderRadius: "8px",
  border: "1px solid #e2e8f0", fontSize: "14px", outline: "none", resize: "none",
  fontFamily: "inherit", transition: "border-color 0.2s",
};

const btnContainer: React.CSSProperties = { display: "flex", gap: "12px", justifyContent: "flex-end", marginTop: "8px" };

const baseBtn: React.CSSProperties = {
  padding: "8px 16px", borderRadius: "8px", fontSize: "14px", fontWeight: 600,
  cursor: "pointer", transition: "all 0.2s", border: "1px solid transparent",
};

const secondaryBtn: React.CSSProperties = { ...baseBtn, background: "#f8fafc", color: "#64748b", borderColor: "#e2e8f0" };

const ReasonModal: React.FC<ReasonModalProps> = ({
  open, onClose, onConfirm, title, description,
  confirmText = "Confirm", confirmColor = "#ef4444",
  placeholder = "Please provide a reason...",
  processing = false,
}) => {
  const [reason, setReason] = useState("");

  if (!open) return null;

  return (
    <div style={overlay} onClick={onClose}>
      <div style={modal} onClick={e => e.stopPropagation()}>
        <div>
          <h3 style={titleStyle}>{title}</h3>
          <p style={descStyle}>{description}</p>
        </div>
        
        <textarea
          style={textareaStyle}
          placeholder={placeholder}
          value={reason}
          onChange={e => setReason(e.target.value)}
          autoFocus
        />

        <div style={btnContainer}>
          <button style={secondaryBtn} onClick={onClose} disabled={processing}>Cancel</button>
          <button
            style={{ ...baseBtn, background: confirmColor, color: "#fff", opacity: processing ? 0.6 : 1, cursor: processing ? "not-allowed" : "pointer" }}
            disabled={processing}
            onClick={() => {
              if (!reason.trim()) return alert("Reason is required");
              onConfirm(reason);
              setReason("");
            }}
          >
            {processing ? "..." : confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReasonModal;
